// import React from 'react'

const STATUS_CLASS = {
  SUCCESS: 'bg-success',
  FAIL: 'bg-danger'
}

export function ApiTrafficStatusBadge ({ status }) {
  const cls = STATUS_CLASS[status] || 'bg-secondary'
  return <span className={`status-${cls}`}>{status}</span>
}

export default ApiTrafficStatusBadge
